export default "__VITE_ASSET__CNOY0GAW__"